<h1 id="title" class="title color-brand">{{ "AUTH.TITLE-LOGIN" | translate }}</h1>
<p class="sub-title">{{ "AUTH.SUB-TITLE" | translate }}</p>

<nb-alert *ngIf="alert.show" [status]="alert.type" role="alert">
    {{ alert.message }}
</nb-alert>

<form aria-labelledby="title" [formGroup]="form" #ngForm="ngForm" (ngSubmit)="login()">
    <div class="form-control-group">
        <label class="label" for="input-email">{{ "GENERAL.MAIL" | translate }}</label>
        <!-- prettier-ignore -->
        <input
            nbInput
            fullWidth
            name="email"
            id="input-email"
            placeholder="{{ 'GENERAL.MAIL' | translate }}"
            autofocus
            formControlName="email"
            [status]="controls.email.dirty ? (controls.email.invalid ? 'danger' : 'success') : ''"
        />
        <ng-container *ngIf="controls.email.invalid && controls.email.touched">
            <p class="error-message" *ngIf="controls.email.errors?.required">
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
            <p class="error-message" *ngIf="controls.email.errors?.pattern">
                {{ "MESSAGE.FIELD.INVALID-MAIL" | translate }}
            </p>
        </ng-container>
    </div>

    <div class="form-control-group">
        <label class="label" for="input-password">{{ "GENERAL.PASSWORD" | translate }}:</label>
        <!-- prettier-ignore -->
        <input
            nbInput
            fullWidth
            name="password"
            type="password"
            id="input-password"
            placeholder="*******"
            formControlName="password"
            [status]="controls.password.dirty ? controls.password.invalid ? 'danger' : 'success' : ''"
        />
        <ng-container *ngIf="controls.password.invalid && controls.password.touched">
            <p class="error-message" *ngIf="controls.password.errors?.required">
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
        </ng-container>
    </div>
    <div style="display: flex; justify-content: center; flex-wrap: wrap; margin-bottom: 12px">
        <re-captcha siteKey="6LeclOUgAAAAAK_OxUwUuzFz8DhMWzA053zQ-1jO" formControlName="recaptcha"></re-captcha>
        <ng-container *ngIf="controls.recaptcha.invalid && controls.recaptcha.touched">
            <p
                class="error-message"
                *ngIf="controls.recaptcha.errors?.required"
                style="width: 100%; text-align: center; margin-bottom: 12px"
            >
                {{ "MESSAGE.FIELD.MANDATORY" | translate }}
            </p>
        </ng-container>
    </div>
    <button nbButton fullWidth status="primary" [disabled]="!ngForm.valid" [class.btn-pulse]="ngForm.submitted">
        Login
    </button>

    <div class="d-flex justify-content-between mt-2">
        <a class="forgot-password caption-2" routerLink="../request-password">{{
            "AUTH.FORGOT-PASSWORD" | translate
        }}</a>

        <a class="forgot-password caption-2" [routerLink]="['/auth/register']">{{ "AUTH.SIGNUP" | translate }}</a>
    </div>
</form>
